import { RangeDateInput, TextInput } from '@core/components/Inputs';
import { SelectInput } from '@core/components/Select';
import { FormControl, Grid } from '@material-ui/core';
import { SelectCliente } from 'app/components/Select';
import { useFormikContext } from 'formik';
import React from 'react';

const GestaoEnvioBuscaAvancadaForm = () => {
  const formik = useFormikContext();

  return (
    <Grid container style={{ padding: 16 }} spacing={3}>
      <Grid item xs={12} sm={12} md={12} xl={12} lg={12}>
        <RangeDateInput
          id="periodoEnvio"
          inputVariant="outlined"
          label="Período de envio"
          value={[formik?.values?.periodoEnvioInicio, formik?.values?.periodoEnvioFim]}
          onChange={(inicio, fim) => {
            formik.setFieldValue('periodoEnvioInicio', inicio);
            formik.setFieldValue('periodoEnvioFim', fim);
          }}
          onBlur={formik.handleBlur}
          onChangeDate={formik.handleChange}
          format="DD/MM/YYYY"
          openTo="date"
          views={['date', 'month', 'year']}
          cancelLabel={false}
          okLabel={false}
          autoOk
          fullWidth
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <SelectCliente
          id="cliente"
          name="cliente"
          label="Cliente"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.cliente}
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <TextInput
          id="email"
          name="email"
          label="E-mail"
          onChange={formik.handleChange}
          onBlur={formik.handleBlur}
          value={formik.values?.email}
          fullWidth
          variant="outlined"
        />
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <FormControl variant="outlined" style={{ width: '100%' }}>
          <SelectInput
            id="situacaoEnvio"
            name="situacaoEnvio"
            label="Situação"
            value={formik.values?.situacaoEnvio}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            options={[
              { id: 'VISUALIZADO', title: 'Visualizado' },
              { id: 'ERRO', title: 'Erro' },
              { id: 'ENVIADO', title: 'Enviado' },
            ]}
          />
        </FormControl>
      </Grid>
      <Grid item xs={12} sm={12} md={12} lg={12} xl={12}>
        <FormControl variant="outlined" style={{ width: '100%' }}>
          <SelectInput
            id="tipoEnvio"
            name="tipoEnvio"
            label="Tipo de envio"
            value={formik.values?.tipoEnvio}
            onChange={formik.handleChange}
            onBlur={formik.handleBlur}
            options={[
              { id: 'CONTAS_RECEBER', title: 'Cobrança' },
              { id: 'ORDEM_SERVICO', title: 'Ordem de serviço' },
              { id: 'VENDA', title: 'Orçamento' },
              { id: 'REGUA_COBRANCA_PASSO', title: 'Régua de cobrança' },
              { id: 'FATURAMENTO_VENDA', title: 'Nota fiscal' },
            ]}
          />
        </FormControl>
      </Grid>
    </Grid>
  );
};

export default GestaoEnvioBuscaAvancadaForm;
